import React from "react";
import { Link } from "react-router-dom";
import { usePrefixContext } from "../../../context/PrefixContext";

import img_FavAdd from "../../../Images/FavAdd.gif";
import img_orT from "../../../Images/orT.gif";

export default function LeagueTitle(props) {
  const { liveTB, pt, dataLg, SportsSelect, SportsPriceSelect, onFavAll } =
    props;
  const prefixContext = usePrefixContext();
  var zone_show = {};
  zone_show["CN"] = dataLg.zone_cn;
  zone_show["EN"] = dataLg.zone_en;
  zone_show["ES"] = dataLg.zone_en;
  zone_show["FR"] = dataLg.zone_en;
  zone_show["IN"] = dataLg.zone_en;
  zone_show["JP"] = dataLg.zone_en;
  zone_show["KH"] = dataLg.zone_en;
  zone_show["KR"] = dataLg.zone_en;
  zone_show["LA"] = dataLg.zone_en;
  zone_show["MM"] = dataLg.zone_en;
  zone_show["PT"] = dataLg.zone_en;
  zone_show["TH"] = dataLg.zone_th;
  zone_show["YN"] = dataLg.zone_en;
  zone_show["RU"] = dataLg.zone_en;
  //var zone_show = (dBall[29]==="" ? dBall[26] : dBall[29]);

  return (
    <div style={{ display: "table-row" }} className="Event">
      {SportsSelect === 1 ? (
        <>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div
            style={{
              display: "table-cell",
              verticalAlign: "middle",
              height: "20px",
              paddingLeft: "5px",
              width: "*",
            }}
          >
            <div style={{ width: "1px" }}>
              <div
                style={{
                  position: "relative",
                  width: "720px",
                  overflow: "hidden",
                }}
              >
                {zone_show[prefixContext.getCurrentLanguage()]}
              </div>
            </div>
          </div>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div
            style={{
              display: "table-cell",
              textAlign: "right",
              verticalAlign: "middle",
            }}
          >
            <Link
              to="/"
              style={{ paddingBottom: "3px", paddingRight: "3px" }}
            >
              <img
                src={img_orT}
                border="0"
                align="absmiddle"
                alt=""
              />
            </Link>
          </div>
        </>
      ) : SportsSelect === 7 ? (
        <>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div
            style={{
              display: "table-cell",
              verticalAlign: "middle",
              height: "20px",
              paddingLeft: "5px",
              width: "*",
            }}
          >
            <div style={{ width: "1px" }}>
              <div
                style={{
                  position: "relative",
                  width: "720px",
                  overflow: "hidden",
                }}
              >
                {zone_show[prefixContext.getCurrentLanguage()]}
              </div>
            </div>
          </div>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div
            style={{
              display: "table-cell",
              textAlign: "right",
              verticalAlign: "middle",
            }}
          >
            <Link
              to="/"
              style={{ paddingBottom: "3px", paddingRight: "3px" }}
            >
              <img
                src={img_orT}
                border="0"
                align="absmiddle"
                alt=""
              />
            </Link>
          </div>
        </>
      ) : SportsPriceSelect === 2 ? (
        <>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div
            style={{
              display: "table-cell",
              verticalAlign: "middle",
              height: "20px",
              paddingLeft: "5px",
              width: "*",
            }}
          >
            <div style={{ width: "1px" }}>
              <div
                style={{
                  position: "relative",
                  width: "720px",
                  overflow: "hidden",
                }}
              >
                {zone_show[prefixContext.getCurrentLanguage()]}
              </div>
            </div>
          </div>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div
            style={{
              display: "table-cell",
              textAlign: "right",
              verticalAlign: "middle",
            }}
          >
            <Link
              to="/"
              style={{ paddingBottom: "3px", paddingRight: "3px" }}
            >
              <img
                src={img_orT}
                border="0"
                align="absmiddle"
                alt=""
              />
            </Link>
          </div>
        </>
      ) : SportsPriceSelect === 3 ? (
        <>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div
            style={{
              display: "table-cell",
              verticalAlign: "middle",
              height: "20px",
              paddingLeft: "5px",
              width: "*",
            }}
          >
            <div style={{ width: "1px" }}>
              <div
                style={{
                  position: "relative",
                  width: "720px",
                  overflow: "hidden",
                }}
              >
                {zone_show[prefixContext.getCurrentLanguage()]}
              </div>
            </div>
          </div>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div
            style={{
              display: "table-cell",
              textAlign: "right",
              verticalAlign: "middle",
            }}
          >
            <Link
              to="/"
              style={{ paddingBottom: "3px", paddingRight: "3px" }}
            >
              <img
                src={img_orT}
                border="0"
                align="absmiddle"
                alt=""
              />
            </Link>
          </div>
        </>
      ) : SportsPriceSelect === 10 ? (
        <>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div
            style={{
              display: "table-cell",
              verticalAlign: "middle",
              height: "20px",
              paddingLeft: "5px",
              width: "*",
            }}
          >
            <div style={{ width: "1px" }}>
              <div
                style={{
                  position: "relative",
                  width: "720px",
                  overflow: "hidden",
                }}
              >
                {zone_show[prefixContext.getCurrentLanguage()]}
              </div>
            </div>
          </div>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div
            style={{
              display: "table-cell",
              textAlign: "right",
              verticalAlign: "middle",
            }}
          >
            <Link
              to="/"
              style={{ paddingBottom: "3px", paddingRight: "3px" }}
            >
              <img
                src={img_orT}
                border="0"
                align="absmiddle"
                alt=""
              />
            </Link>
          </div>
        </>
      ) : pt === 0 ? (
        <>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div
            style={{
              display: "table-cell",
              verticalAlign: "middle",
              height: "20px",
              paddingLeft: "5px",
              width: "*",
            }}
          >
            <div style={{ width: "1px" }}>
              <div
                style={{
                  position: "relative",
                  width: "680px",
                  overflow: "hidden",
                }}
              >
                {zone_show[prefixContext.getCurrentLanguage()]}
              </div>
            </div>
          </div>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div
            style={{
              display: "table-cell",
              textAlign: "right",
              verticalAlign: "middle",
            }}
          >
            <div style={{ width: "1px" }}>
              <div
                style={{
                  position: "relative",
                  width: "40px",
                  overflow: "hidden",
                  left: "-20px",
                }}
              >
                <Link
              to="/"
              style={{ paddingBottom: "3px", paddingRight: "3px" }}
              onClick={onFavAll}
            >
              <img
                title="Add All"
                src={img_FavAdd}
                border="0"
                align="absmiddle"
                alt=""
              />
            </Link>
            <Link
              to="/"
              style={{ paddingBottom: "3px", paddingRight: "3px" }}
            >
              <img
                src={img_orT}
                border="0"
                align="absmiddle"
                alt=""
              />
            </Link>
              </div>
            </div>
            
          </div>
        </>
      ) : pt === 99 ? (
        <>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div
            style={{
              display: "table-cell",
              verticalAlign: "middle",
              height: "20px",
              paddingLeft: "5px",
              width: "*",
            }}
          >
            <div style={{ width: "1px" }}>
              <div
                style={{
                  position: "relative",
                  width: "680px",
                  overflow: "hidden",
                }}
              >
                {zone_show[prefixContext.getCurrentLanguage()]}
              </div>
            </div>
          </div>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          {liveTB === 1 ? (
            ""
          ) : (
            <div style={{ display: "table-cell" }}>&nbsp;</div>
          )}
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div
            style={{
              display: "table-cell",
              textAlign: "right",
              verticalAlign: "middle",
            }}
          >
            <Link
              to="/"
              style={{ paddingBottom: "3px", paddingRight: "3px" }}
              onClick={onFavAll}
            >
              <img
                title="Add All"
                src={img_FavAdd}
                border="0"
                align="absmiddle"
                alt=""
              />
            </Link>
            <Link
              to="/"
              style={{ paddingBottom: "3px", paddingRight: "3px" }}
            >
              <img
                src={img_orT}
                border="0"
                align="absmiddle"
                alt=""
              />
            </Link>
          </div>
        </>
      ) : pt === 2 ? (
        ""
      ) : pt === 1 || SportsPriceSelect === 4 ? (
        <>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div
            style={{
              display: "table-cell",
              verticalAlign: "middle",
              height: "20px",
              paddingLeft: "5px",
              width: "*",
            }}
          >
            <div style={{ width: "1px" }}>
              <div
                style={{
                  position: "relative",
                  width: "680px",
                  overflow: "hidden",
                }}
              >
                {zone_show[prefixContext.getCurrentLanguage()]}
              </div>
            </div>
          </div>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div style={{ display: "table-cell" }}>&nbsp;</div>
          <div
            style={{
              display: "table-cell",
              textAlign: "right",
              verticalAlign: "middle",
            }}
          >
            { SportsPriceSelect!==4 ? <Link
              to="/"
              style={{ paddingBottom: "3px", paddingRight: "3px" }}
              onClick={onFavAll}
            >
              <img
                title="Add All"
                src={img_FavAdd}
                border="0"
                align="absmiddle"
                alt=""
              />
            </Link> : null}
            <Link
              to="/"
              style={{ paddingBottom: "3px", paddingRight: "3px" }}
            >
              <img
                src={img_orT}
                border="0"
                align="absmiddle"
                alt=""
              />
            </Link>
          </div>
        </>
      ) : (
        ""
      )}
    </div>
  );
}
